import { render } from "./matching-list-mobile.vue?vue&type=template&id=3408c7f9&scoped=true&ts=true"
import script from "./matching-list-mobile.vue?vue&type=script&lang=ts"
export * from "./matching-list-mobile.vue?vue&type=script&lang=ts"

import "./matching-list-mobile.vue?vue&type=style&index=0&id=3408c7f9&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3408c7f9"]])

export default __exports__